import { createFileRoute } from "@tanstack/react-router";
import PrTmsAdhdPage from "@/pages/PrTmsAdhdPage";
export const Route = createFileRoute("/prtms-for-adhd-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "PrTMS for ADHD Treatment Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Non-pharmaceutical PrTMS therapy for ADHD & ADD in Coral Springs, FL. EEG-guided magnetic stimulation to improve focus, organization & impulse control.",
        },
        {
          property: "og:title",
          content:
            "PrTMS for ADHD Treatment Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Non-pharmaceutical PrTMS therapy for ADHD & ADD in Coral Springs, FL. EEG-guided magnetic stimulation to improve focus, organization & impulse control.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/prtms-for-adhd-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prtms-for-adhd-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PrTmsAdhdPage />;
}
